import { ALL_LANES } from "src/types/global";
import { usePatchStore } from "src/services/patch-ecosystem-store";
import { ChampionIcon } from "@procomps/shared";

function STierView() {
  const { championDB } = usePatchStore();

  function getSTierChampions(lane: string) {
    const laneKey = "Lanes_" + lane;
    const tierKey = "Tier_List_" + lane;
    return championDB.filter(
      (champion: any) => champion[laneKey] === "Yes" && champion[tierKey] === "S",
    );
  }
  return (
    <div className="flex w-full flex-col items-start justify-center gap-10">
      <div className="flex w-full items-center  justify-between max-[1113px]:flex-col max-[1113px]:items-start max-[1113px]:gap-2">
        <div className="font-unbounded text-[20px] font-extrabold uppercase leading-6 text-neutral-0 ">
          Top Champions of the Patch
        </div>
        <div className="max-w-[572px] font-poppins text-[#8E8E8E] ">
          Discover the most dominant champions of the current patch based on patch changes and meta
          shifts. These S Tier picks define the meta and offer strong advantages across most
          matchups.
        </div>
      </div>
      <div className="flex w-full  flex-col items-start justify-center gap-8">
        {ALL_LANES.map((lane, index) => (
          <div
            className="flex w-full items-center justify-between  rounded-full border border-[#393939] px-20
             py-10 max-[1146px]:flex-col max-[1146px]:justify-center max-[1146px]:gap-4 max-[1146px]:rounded-[64px] max-[1146px]:px-10 "
            key={index}
          >
            <img src={require(`src/assets/icons/lanes_primary/${lane}.PNG`)} alt={lane} />
            <div className="flex flex-wrap items-center justify-end gap-11 max-[1520px]:gap-8 max-[1365px]:gap-4 max-[1146px]:justify-center ">
              {getSTierChampions(lane).map((champion: any) => (
                <ChampionIcon
                  champion={champion.Champion}
                  className="  h-[120px] w-[120px]
                  max-[1680px]:h-[100px] max-[1680px]:w-[100px]
                  max-[1520px]:h-[90px] max-[1520px]:w-[90px] 
                  max-[1365px]:h-[80px] max-[1365px]:w-[80px] "
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default STierView;
